var x = function(y) {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = function(x) { return function() { return x; }; }
var __WEBPACK_NAMESPACE_OBJECT__ = x({ ["Provider"]: function() { return __WEBPACK_EXTERNAL_MODULE_react_redux_87be03b0__.Provider; }, ["connect"]: function() { return __WEBPACK_EXTERNAL_MODULE_react_redux_87be03b0__.connect; } });